import React from 'react';
import logoiii from '../assets/logoiii.png';

const SplashScreen = () => {
  return (
    <div className="fixed top-0 left-0 w-full h-full flex flex-col items-center justify-center bg-gradient-to-b from-black via-gray-900 to-black">
      <div className="flex flex-col items-center">
        <img 
          src={logoiii} 
          alt="Logo de EPICMOVIE" 
          className="w-28 h-28 animate-pulse" 
        />
        <div className="mt-4 flex items-center animate-fadeIn">
          <h1 className="text-3xl md:text-5xl font-bold text-white tracking-wider">
            EPIC <span className="text-blue-500">MOVIE</span>
          </h1>
        </div>
        <div className="mt-8">
          <div className="w-16 h-1 bg-blue-600 rounded-full animate-pulse"></div>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;